import { Component, ViewEncapsulation, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from '../../../core/services/cart.service';
import { WishListService } from '../../../core/services/wish-list.service';
import { isDef } from '../../../utils';

@Component({
  selector: 'cart-item',
  templateUrl: './cart-item.component.html',
  styleUrls: ['./cart-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CartItemComponent {
  @Input() item;

  constructor(
    private cart: CartService,
    private wishList: WishListService,
    private router: Router
    ) {}

  backgroundImage() {
    let url = '';
    if (this.item.images['264x179']) {
      url = this.item.images['264x179'];
    } else {
      url = "/assets/img/logo-template.png";
    }
    return `url(${url})`;
  }

  isItemLoaded () {
    return isDef(this.item);
  }

  isItemDeactivated () {
    return this.item.states.trashed;
  }

  goToItem () {
    if (!this.isItemDeactivated()) {
      this.router.navigate(['/products', this.item.id]);
    }
  }

  removeFromCart () {
    this.cart.removeProductFromCart(this.item);
  }

  isInWishList () {
    return this.wishList.isProductInTheWishList(this.item.id);
  }

  addToWishList () {
    if (!this.isItemDeactivated()) {
      this.wishList.addToWishList(this.item);
    }
  }

  removeFromWishList () {
    this.wishList.removeFromWishList(this.item);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/cart/cart-item/cart-item.component.ts